import{formatDate as r}from"../i18n/formatDate.js";import{formatCurrency as t}from"../i18n/formatCurrency.js";const o=()=>({firstDayOfWeek:1,formatCurrency:t,formatDate:r});export{o as useLocalisation};
//# sourceMappingURL=useLocalisation.js.map
